import React, { Component } from 'react';
import Radium from 'radium';
import PropTypes from 'prop-types';

import { handleChange } from 'utils/ComponentUtilFunctions';
import MessageEditControls from './MessageEditControls';
import {updateHardcodedMessageStatus} from "../../../../../services/company/api";

const styles = {
  wrapper: {
    border: '1px solid rgb(4, 62, 92)',
    padding: '8px 16px',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    margin: '5px',
    borderRadius: '10px'
  },
  textEdit: {
    width: '100%',
    border: 'none',
    background: 'transparent',
    resize: 'none',
  },
  text: {
    wordBreak: 'break-all',
    width: '100%',
  },
  hide: {
    display: 'none',
  },
};

class ButtonMessageEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editing: false,
      currentValue: ''
    };
    this.handleChange = handleChange.bind(this);
    this.input = React.createRef();
  }


  handleEditIconClick = () => {
    const { value } = this.props;
    this.setState({
      editing: true,
      currentValue: value,
    }, (() => { this.input.current.focus(); }));
  };

  handleCancel = () => {
    this.setState({
      editing: false,
      currentValue: '',
    });
  };

  handleSave = () => {
    const { updateMessage } = this.props;
    const { currentValue } = this.state;
    return updateMessage(currentValue).then(this.setState({
      editing: false,
      currentValue: '',
    }));
  };


  render() {
    const { editing, currentValue } = this.state;
    const { value, type, hardCodedMessagesStatusData, handleCheckboxChange } = this.props;

    return (
      <div style={styles.wrapper}>
        <input
          ref={this.input}
          style={editing ? styles.textEdit : [styles.text, styles.hide]}
          onChange={this.handleChange('currentValue')}
          value={currentValue}
          maxLength="20"
        />
        <div style={editing ? [styles.text, styles.hide] : styles.text}>
          {value}
        </div>
        {/*<label style={{marginRight: '10px', marginLeft: '10px'}} className="switch controller">*/}
          {/*<input*/}
          {/*    type="checkbox"*/}
          {/*    checked={hardCodedMessagesStatusData[type]}*/}
          {/*    onChange={() => handleCheckboxChange(type)}*/}
          {/*/>*/}
        {/*  <span className="slider round"/>*/}
        {/*</label>*/}
        <MessageEditControls
          editing={editing}
          handleEditIconClick={this.handleEditIconClick}
          handleCancel={this.handleCancel}
          handleSave={this.handleSave}
        />
      </div>
    );
  }
}

ButtonMessageEdit.propTypes = {
  value: PropTypes.string.isRequired,
  updateMessage: PropTypes.func.isRequired,
};

export default Radium(ButtonMessageEdit);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/ButtonMessageEdit.jsx